// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkBanner_LinkBanner__X85ZM {
  padding: 0.5vw;
  --highlight-color: \$globalHighlightColor;
}
.LinkBanner_LinkBanner__X85ZM a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8rem;
  height: 4rem;
}
@media only screen and (max-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM a {
    width: 4rem;
    height: 2rem;
  }
}
.LinkBanner_LinkBanner__X85ZM a {
  position: relative;
  border-radius: 10rem;
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_imageContainer__I6vwJ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.7rem;
  width: 2.7rem;
}
@media only screen and (max-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_imageContainer__I6vwJ {
    width: 2rem;
    height: 2rem;
  }
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_textContainer__HiuGn {
  position: absolute;
  text-align: center;
  bottom: 0;
  opacity: 0;
  border-radius: 50vw;
  font-size: 0.96rem;
  transition: opacity 0.1s ease-in-out;
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10rem;
}
@media only screen and (max-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA {
    border: solid var(--highlight-color);
  }
}
@media only screen and (min-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA {
    border: solid transparent;
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA:hover {
    border: solid var(--highlight-color);
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA:hover .LinkBanner_textContainer__HiuGn {
    opacity: 1;
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA:hover img {
    transform: translate(0%, -20%);
  }
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA {
  --highlight-color: #fafafa;
  cursor: pointer;
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_darkTheme__ku3uA .LinkBanner_imageContainer__I6vwJ {
  filter: invert(1);
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10rem;
}
@media only screen and (max-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf {
    border: solid var(--highlight-color);
  }
}
@media only screen and (min-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf {
    border: solid transparent;
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf:hover {
    border: solid var(--highlight-color);
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf:hover .LinkBanner_textContainer__HiuGn {
    opacity: 1;
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf:hover img {
    transform: translate(0%, -20%);
  }
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_lightTheme__vTHMf {
  --highlight-color: #454555;
  cursor: pointer;
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1 {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10rem;
}
@media only screen and (max-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1 {
    border: solid var(--highlight-color);
  }
}
@media only screen and (min-width: 768px) {
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1 {
    border: solid transparent;
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1:hover {
    border: solid var(--highlight-color);
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1:hover .LinkBanner_textContainer__HiuGn {
    opacity: 1;
  }
  .LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1:hover img {
    transform: translate(0%, -20%);
  }
}
.LinkBanner_LinkBanner__X85ZM .LinkBanner_colorfulTheme__vm0h1 {
  --highlight-color: #fafafa;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/LinkBanner/LinkBanner.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,wCAAA;AADF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAGI;EANF;IAOI,WAAA;IACA,YAAA;EAAJ;AACF;AATE;EAUE,kBAAA;EACA,oBAAA;AAEJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AAAJ;AACI;EANF;IAOI,WAAA;IACA,YAAA;EAEJ;AACF;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;AADJ;AA8BE;ECfA,gBAAA;EACA,sBAAA;EACA,2CAnD4B;EDuC1B,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AAAI;EAmBF;IAlBI,oCAAA;EAGJ;AACF;AADI;EAeF;IAdI,yBAAA;EAIJ;EAHI;IACE,oCAAA;EAKN;EAHI;IACE,UAAA;EAKN;EAHI;IACE,8BAAA;EAKN;AACF;AAAE;EAGE,0BAAA;EACA,eAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAKE;ECrBA,gBAAA;EACA,sBAAA;EACA,0CAxD6B;EDsC3B,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAsCJ;AArCI;EA+BF;IA9BI,oCAAA;EAwCJ;AACF;AAtCI;EA2BF;IA1BI,yBAAA;EAyCJ;EAxCI;IACE,oCAAA;EA0CN;EAxCI;IACE,UAAA;EA0CN;EAxCI;IACE,8BAAA;EA0CN;AACF;AAzBE;EAGE,0BAAA;EACA,eAAA;AAyBJ;AAtBE;ECtBA,gBAAA;EACA,sBAAA;EACA,0CA9D6B;EDsC3B,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAwEJ;AAvEI;EAsCF;IArCI,oCAAA;EA0EJ;AACF;AAxEI;EAkCF;IAjCI,yBAAA;EA2EJ;EA1EI;IACE,oCAAA;EA4EN;EA1EI;IACE,UAAA;EA4EN;EA1EI;IACE,8BAAA;EA4EN;AACF;AApDE;EAGE,0BAAA;EACA,eAAA;AAoDJ","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.LinkBanner {\n  padding: 0.5vw;\n  --highlight-color : $globalHighlightColor;\n\n\n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 8rem;\n    height: 4rem;\n    @media only screen and (max-width: 768px) {\n      width: 4rem;\n      height: 2rem;\n    }\n    position: relative;\n    border-radius: $globalBorderRadius * 10;\n\n  }\n\n  .imageContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 2.7rem;\n    width: 2.7rem;\n    @media only screen and (max-width: 768px) {\n      width: 2rem;\n      height: 2rem;\n    }\n  }\n\n\n\n  .textContainer {\n    position: absolute;\n    text-align: center;\n    bottom: 0;\n    opacity: 0;\n    border-radius: 50vw;\n    font-size: $globalFontSize * 0.8;\n    transition: opacity 0.1s ease-in-out;\n  }\n\n  @mixin contentStyling {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    border-radius: $globalBorderRadius * 10;\n    @media only screen and (max-width: 768px) {\n      border: solid var(--highlight-color);\n    }\n\n    @media only screen and (min-width: 768px) {\n      border: solid transparent;\n      &:hover {\n        border: solid var(--highlight-color);\n      }\n      &:hover .textContainer {\n        opacity: 1;\n      }\n      &:hover img {\n        transform: translate(0%, -20%);\n      }\n\n    }\n  }\n\n  .darkTheme {\n    @include darkThemeContent;\n    @include contentStyling;\n    --highlight-color: #{$globalHighlightColorDark};\n    cursor: pointer;\n\n    .imageContainer {\n      filter: invert(1);\n    }\n\n  }\n\n  .lightTheme {\n    @include lightThemeContent;\n    @include contentStyling;\n    --highlight-color: #{$globalHighlightColorLight};\n    cursor: pointer;\n  }\n\n  .colorfulTheme {\n    @include colorfulThemeContent;\n    @include contentStyling;\n    --highlight-color: #{$globalHighlightColorDark};\n    cursor: pointer;\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LinkBanner": `LinkBanner_LinkBanner__X85ZM`,
	"imageContainer": `LinkBanner_imageContainer__I6vwJ`,
	"textContainer": `LinkBanner_textContainer__HiuGn`,
	"darkTheme": `LinkBanner_darkTheme__ku3uA`,
	"lightTheme": `LinkBanner_lightTheme__vTHMf`,
	"colorfulTheme": `LinkBanner_colorfulTheme__vm0h1`
};
export default ___CSS_LOADER_EXPORT___;
